import { PageHero } from "./Services";

export function Legal({ kind }) {
  return (
    <div>
      <PageHero label="Legal" title={kind === "privacy" ? "Privacy Policy" : "Terms of Service"} />
      <div className="max-w-3xl mx-auto px-6 py-14 text-slate-700 space-y-4 text-sm leading-relaxed">
        <p>{kind === "privacy"
          ? "Thomason Digital Works respects your privacy. We collect only the information needed to respond to your requests and provide services. We never sell your data. We never request passwords, authentication codes, full card numbers, or bank credentials. You may request data export or account deletion at any time."
          : "By using TDW Nexus AI you agree to use the service lawfully. Nexus provides general guidance only and does not constitute a confirmed technical diagnosis. Estimates are drafts until approved by our team. Payment processing is handled by PCI-compliant providers. Digital downloads are licensed for your own use."}</p>
        <p className="text-slate-500">This is a summary policy for the initial release. A full legal document will be published as the platform matures.</p>
      </div>
    </div>
  );
}
